
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Classification} from '../../../models/classification.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/primeng';
import {ClassificationService} from '../../../services/classification/classification.service';

@Component({
  selector: 'app-classification-form',
  templateUrl: './classification-form.component.html'
})
export class ClassificationForm2Component implements OnChanges {


  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement:  Classification;

  addEditForm: FormGroup;

  classifications_items: SelectItem[];
  selected_classification: any;

  classification_types: SelectItem[];
  selected_classification_type: any;

  constructor(private fb: FormBuilder,
              private svcClassification: ClassificationService) {

    console.log('constructor')
    this.classifications_items = [];
    this.classification_types = [];

      this.svcClassification.list.forEach(c => {
        this.classifications_items.push({
          label: c.name,
          value: c.id
        })
      })

      this.svcClassification.types.forEach(t => {
        this.classification_types.push({
          label: t.name,
          value: t.id
        })
      })

  }


  ngOnChanges(changes: SimpleChanges): void {
    this.addEditForm = this.fb.group({
      'name': new FormControl(this.editingElement.name, Validators.compose([Validators.required, Validators.maxLength(100)])),
      'parent_id': new FormControl(this.editingElement.parent_id, Validators.compose([Validators.required])),
      'classification_type_id': new FormControl(this.editingElement.classification_type_id, Validators.compose([Validators.required])),
    });
    console.log('ngChanges')
  }

  saveOrUpdate(): void {

    let newData = Object.assign({}, this.editingElement, this.addEditForm.value);
    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-form.component.ts